import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-label small mb-1" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-label small mb-1" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-label small mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_rte_editor = _resolveComponent("rte-editor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _createVNode(_component_localized_text, {
          localizedKey: "Testo bottone superiore",
          text: "Testo bottone superiore"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.topButtonText) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.topButtonText]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Href bottone superiore",
          text: "Href bottone superiore"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.topButtonHref) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.topButtonHref]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _createVNode(_component_localized_text, {
          localizedKey: "Contenuto",
          text: "Contenuto"
        })
      ]),
      _createVNode(_component_rte_editor, {
        class: "form-control",
        modelValue: _ctx.localValue.text,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.text) = $event)),
        height: "200"
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}